const PATCH_MARK = '__xuperRawTitlePatched'

function getRawCellTitle(value) {
    if (value === null || value === undefined) return ''
    if (typeof value === 'object') {
        try {
            return JSON.stringify(value)
        } catch (error) {
            return ''
        }
    }
    return String(value)
}

function patchBodyCellOptions(options) {
    if (!options || options.name !== 'VeTableBodyTd' || !options.methods) return

    const originalGetRenderContent = options.methods.getRenderContent
    if (typeof originalGetRenderContent !== 'function' || originalGetRenderContent[PATCH_MARK]) return

    const getRenderContent = function (h) {
        const content = originalGetRenderContent.call(this, h)
        const column = this.column
        const ellipsis = column && column.ellipsis
        if (!ellipsis || ellipsis.showTitle === false || !content || !content.data) return content

        const hasCurrentValue = this.rowData && column && Object.prototype.hasOwnProperty.call(this.rowData, column.field)
        const rawValue = hasCurrentValue ? this.rowData[column.field] : this.rawCellValue
        content.data.attrs = Object.assign({}, content.data.attrs, {
            title: getRawCellTitle(rawValue),
        })
        return content
    }

    getRenderContent[PATCH_MARK] = true
    options.methods.getRenderContent = getRenderContent
}

export default function installVeTableRawTitlePatch(Vue) {
    Vue.mixin({
        beforeCreate() {
            patchBodyCellOptions(this.$options)
        },
    })
}
